<div class="header flex justify-start content-stretch items-stretch flex-row">
  <a class="logo" [routerLink]="['/home']">
    <img [src]="'/assets/unite-logo-' + subscription.toLowerCase() + '.svg'" alt="Unite">
  </a>

  <mat-toolbar class="flex flex-row justify-start content-center items-center h-full gap-[0.25rem] flex-1">
    <button fxHide.gt-sm="" mat-icon-button="" (click)="toggleGeneralSideNav()" class="header-icon-button xl:!hidden">
      <mat-icon>menu</mat-icon>
    </button>

    @if (hasLeftSidenav === true) {
      <button fxHide.gt-sm="" mat-icon-button="" (click)="toggleLeftSideNav()" class="header-icon-button xl:!hidden">
        <mat-icon>person_outline</mat-icon>
      </button>
    }

    @if (isProfessional) {
      <button fxHide.lt-md="" mat-icon-button="" class="header-icon-button max-xl:!hidden" [matMenuTriggerFor]="listsMenu">
        <mat-icon>list</mat-icon>
      </button>
    }

    <mat-menu overlapTrigger="false" #listsMenu="matMenu">
      <a mat-menu-item="" [routerLink]="['/customers']" [routerLinkActive]="['active']">
        <mat-icon>person_outline</mat-icon>
        <span translate="">Clients</span>
      </a>
      <a mat-menu-item="" [routerLink]="['/buildings']" [routerLinkActive]="['active']">
        <mat-icon>business</mat-icon>
        <span translate="">Buildings</span>
      </a>
      <a mat-menu-item="" [routerLink]="['/financings']" [routerLinkActive]="['active']">
        <mat-icon>euro_symbol</mat-icon>
        <span translate="">Financings</span>
      </a>
      <a mat-menu-item="" [routerLink]="['/applications']" [routerLinkActive]="['active']">
        <mat-icon>access_time</mat-icon>
        <span translate="">Applications</span>
      </a>
      <a mat-menu-item="" [routerLink]="['/mortgages']" [routerLinkActive]="['active']">
        <mat-icon>folder_open</mat-icon>
        <span translate="">Ongoing mortgages</span>
      </a>
      <a mat-menu-item="" [routerLink]="['/tasks']" [routerLinkActive]="['active']">
        <mat-icon>assignment</mat-icon>
        <span translate="">Tasks</span>
      </a>
      <a mat-menu-item="" [routerLink]="['/reports']" [routerLinkActive]="['active']">
        <mat-icon>real_estate_agent</mat-icon>
        <span translate="">Reports</span>
      </a>
    </mat-menu>

    @if (isProfessional) {
      <button fxHide.lt-md="" mat-icon-button="" class="header-icon-button max-xl:hidden" [matMenuTriggerFor]="addMenu">
        <mat-icon>add</mat-icon>
      </button>
    }
    <mat-menu overlapTrigger="false" #addMenu="matMenu">
      <div translate="" class="mat-subtitle-2 gray pt1 px2">Add new</div>
      <button mat-menu-item="" (click)="openCreateCustomerDialog()">
        <mat-icon>person_outline</mat-icon>
        <span translate="">Client</span>
      </button>
    </mat-menu>

    <unite-search-box-v2 fxHide.lt-sm="" [placeholder]=" ( isProfessional ? 'Search for client, property, mortgage' : 'Search for application' )  | translate" class="basis-full max-lg:hidden">
    </unite-search-box-v2>

    @if (isProfessional) {
      <a href="https://unite.nl/faq/" target="_blank" mat-icon-button="" class="header-icon-button">
        <mat-icon>help_outline</mat-icon>
      </a>
    }

    <div fxHide.gt-xs="" class="flex-1 sm:hidden"></div>

    <button mat-icon-button="" [matMenuTriggerFor]="settingsMenu" class="header-icon-button">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu overlapTrigger="false" #settingsMenu="matMenu">
      @if (currentLanguage != 'en-US') {
        <button [matTooltip]="'The browser will reload' | translate" matTooltipPosition="left" mat-menu-item="" (click)="setLanguage('en-US')">
          <mat-icon>language</mat-icon>
          <span translate="">Set to English</span>
        </button>
      }
      @if (currentLanguage != 'nl-NL') {
        <button [matTooltip]="'The browser will reload' | translate" matTooltipPosition="left" mat-menu-item="" (click)="setLanguage('nl-NL')">
          <mat-icon>language</mat-icon>
          <span translate="">Set to Dutch</span>
        </button>
      }
      <button mat-menu-item="">
        <mat-icon>person_outline</mat-icon>
        <span>{{loginName}}</span>
      </button>
      <a mat-menu-item="" [routerLink]="['/settings/portal-logins']">
        <mat-icon>key</mat-icon>
        <span translate="">SolidBriQ login</span>
      </a>
      @if (userIsAdministrator) {
        <a mat-menu-item="" [routerLink]="['/settings']">
          <mat-icon>settings</mat-icon>
          <span translate="">Settings</span>
        </a>
      }
      @if (userIsAdministrator) {
        <a mat-menu-item="" [routerLink]="['/settings/rates']">
          <mat-icon>admin_panel_settings</mat-icon>
          <span translate="">Rate settings</span>
        </a>
        <a mat-menu-item="" [routerLink]="['/settings/admin']">
          <mat-icon>manage_accounts</mat-icon>
          <span translate="">Admin settings</span>
        </a>
      }
      @if (hasPortal) {
        <a mat-menu-item="" [routerLink]="['/portal']">
          <mat-icon>phonelink</mat-icon>
          <span translate="">Portal</span>
        </a>
      }
      @if (isCombinedProposalsEnabledAccount) {
        <a mat-menu-item="" [routerLink]="['/combined-proposals/overview']">
          <mat-icon><span class="material-icons">
            calculate
          </span></mat-icon>
          <span translate="">Combined proposals</span>
        </a>
      }
      <button mat-menu-item="" (click)="logout()">
        <mat-icon>swap_horiz</mat-icon>
        <span translate="">Logout</span>
      </button>
    </mat-menu>
  </mat-toolbar>
</div>